module.exports = __webpack_public_path__ + "img/stock6.5c95c32a.png";